import { Getters } from 'vuex-smart-module';
import PatchNotesState from './state';

export default class PatchNotesGetters extends Getters<PatchNotesState> { }
